import React from 'react';
import AppPage from './AppPage';

function ChecklistIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#1ABC9C" />
      <path
        d="M7 12.5l3 3 7-7"
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DoneView({ state }) {
  // The portal invite goes to the POC — the merchant-facing address for
  // every customer email. The billing contact only receives invoices.
  const email = state?.email;

  return (
    <AppPage>
      <div className="confirm-check">
        <svg viewBox="0 0 24 24" fill="none">
          <path
            d="M5 13l4 4L19 7"
            stroke="#1ABC9C"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <h1 className="signup-title">You&apos;re all set!</h1>
      <p className="signup-sub">
        {state?.business || 'Your brand'} is signed up.
      </p>
      <div className="signup-checklist">
        <div className="checklist-item">
          <ChecklistIcon />
          Order form signed
        </div>
        <div className="checklist-item">
          <ChecklistIcon />
          Payment method on file
        </div>
      </div>
      <p className="text-sm text-up-clr-dark-grey leading-relaxed">
        We&apos;re creating your UrbanPiper portal now. Your invite will
        arrive
        {email ? (
          <>
            {' '}
            at <span className="font-semibold text-up-clr-black">{email}</span>
          </>
        ) : (
          ' by email'
        )}{' '}
        shortly — you can close this page.
      </p>
    </AppPage>
  );
}

export default DoneView;
